import React from "react";
import { Section, Heading, Gallery, Image } from "../designcss/certificateStyled";

const certificates = [
  {
    link: "https://cyberpro.dict.gov.ph/verify/CPB-FXW1-F892-QGJK-2AH9",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1790134815/dict-cyberpro-badge_m9vbkd.png",
    alt: "DICT Cybersecurity Badge",
  },
  {
    link: "https://www.credly.com/badges/d53d4520-31bf-4edd-8e4c-048737423a46",
    src: "https://images.credly.com/size/340x340/images/af8c6b4e-fc31-47c4-8dcb-eb7a2065dc5b/I2CS__1_.png",
    alt: "I2CS Certificate",
  },
  {
    link: "https://www.credly.com/badges/932ce8ed-4d54-41b5-b369-709e83eb81d3",
    src: "https://images.credly.com/size/340x340/images/054913b2-e271-49a2-a1a4-9bf1c1f9a404/CyberEssentials.png",
    alt: "Cyber Essentials Certificate",
  },
  {
    link: "https://www.sololearn.com/en/certificates/CT-ZVJI0XPA",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742214503/Responsive_Design_r8xndm.png",
    alt: "Responsive Design Certificate",
  },
  {
    link: "https://www.sololearn.com/en/certificates/CT-EV5MKSAM",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742216411/python_intermidiate_vygre0.png",
    alt: "Python Intermediate Certificate",
  },
  {
    link: "https://skillshop.credential.net/5d50d538-580c-45fa-b714-6c2b9b3a5cd8#acc.LeSjBVqW",
    src: "https://images.credential.net/embed/vl7cdrvx.png",
    alt: "Google Ads Certificate",
  },
  {
    link: "https://tesda.gov.ph/Rwac/Verification?LastName=porte&FirstName=albiemer&firstfour=1305&lastfour=7628",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742220460/tesda_yawz8i.jpg",
    alt: "TESDA Certificate",
  },
  {
    link: "https://www.sololearn.com/en/certificates/CT-CZ2VN4DT",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742226065/python_core_oprfmy.png",
    alt: "Python Core Certificate",
  },
  {
    link: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742227167/iwsp_klt076.jpg",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742227167/iwsp_klt076.jpg",
    alt: "IWSP Certificate",
  },
  {
    link: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742227411/marketing_oqhltd.jpg",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742227411/marketing_oqhltd.jpg",
    alt: "Marketing Certificate",
  },
  {
    link: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742227658/cccert_dmbh4w.jpg",
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1742227658/cccert_dmbh4w.jpg",
    alt: "CC Certificate",
  },
];

const MyCertificate = () => {
  return (
    <Section>
      <Heading>Certificate</Heading>
      <Gallery>
        {certificates.map((cert, index) => (
          <a key={index} href={cert.link} target="_blank" rel="noopener noreferrer">
            <Image src={cert.src} alt={cert.alt} loading="lazy" />
          </a>
        ))}
      </Gallery>
    </Section>
  );
};

export default MyCertificate;
